import { useEffect, useRef } from "react";

import ListEntitiesItem from "components/ListEntitiesItem";
import ListEntitiesItemLink from "components/ListEntitiesItem/Link";
import Timestamp from "components/Timestamp";
import Box from "ds/components/Box";
import { WebhookDelivery } from "types/generated";
import WebhookDeliveriesStatus from "views/Account/Integrations/registry/Webhooks/ItemPage/Deliveries/Status";

import { COLUMN_ORDER } from "./constants";

type WebhookDeliveryListItemProps = {
  item: WebhookDelivery;
  setRowHeight?: (size: number) => void;
};

const WebhookDeliveryListItem = ({ item, setRowHeight }: WebhookDeliveryListItemProps) => {
  const rowRef = useRef<HTMLDivElement>(null);

  const handleRowHeight = () => {
    if (setRowHeight && rowRef.current) {
      setRowHeight(rowRef.current.getBoundingClientRect().height);
    }
  };

  // on every render, update the row height
  useEffect(handleRowHeight);

  return (
    <ListEntitiesItem
      direction="row"
      align="center"
      justify="between"
      grid
      gridTemplate={COLUMN_ORDER}
      gap="0 large"
      ref={rowRef}
    >
      <Box align="center">
        <ListEntitiesItemLink href={`delivery/${encodeURIComponent(item.id)}`} title={item.id} />
      </Box>
      <Box align="center">
        <WebhookDeliveriesStatus status={item.status} />
      </Box>
      <Box align="center">
        <Timestamp timestamp={item.timestamp} variant="p-body2" />
      </Box>
    </ListEntitiesItem>
  );
};

export default WebhookDeliveryListItem;
